<template>
  <div id="app">

    <div class="main">
      <!-- <router-view></router-view> -->
      <!-- <indexIndex></indexIndex> -->
    </div>

    <!--<div>版本号v20190827</div>-->
  </div>
</template>
<script type="text/ecmascript-6">
  // import "babel-polyfill"; //IE9，模拟ES6环境
  // import "@/common/less/index.less";
  import {
    cookie
  } from "@/common/js/cookies.js";
  // import indexIndex from "@/components/index/index_index";
  export default {
    data() {
      return {
        routerUrl: null
      };
    },
    // beforeRouteEnter: (to,from,next) => {
    // 	var urlRouter = window.location.href;
    // 	if(urlRouter.indexOf('token=') > 0){
    // 	  deleteCookie('xyxf_token_qt');
    // 	  setCookie('xyxf_token_qt', urlRouter.split('token=')[1] , 1);
    // 	  console.log(1)
    // 	}
    // 	next(vm =>{
    // 		vm.$router.push('/')
    // 	})
    // },
    computed: {},
    beforeCreate() {
      var urlRouter = window.location.href;
      if (urlRouter.indexOf('token=') > 0) {
        // deleteCookie('xyxf_token_qt');
        cookie.delete("xyxf_token_qt");
        let url = urlRouter.split('token=')[1];
        let urlList = url.split('&');
        let routerUrl=null;
        if (url.indexOf('&') > 0) {
          urlList.forEach((item, index) => {
            if (item.indexOf('router=') != -1) {
               routerUrl = item.split('router=')[1];
            }
          })
        }
        cookie.set("xyxf_token_qt", urlList[0], 1);
        setTimeout(() => {
          if (routerUrl) {
            this.$router.push({
              path: '/' + routerUrl
            })
          } else {
            this.$router.push({
              path: '/'
            })
          }
        }, 100)
        // setCookie('xyxf_token_qt', urlRouter.split('token=')[1], 1);
      }
    },
    created: function() {

    },
    mounted() {
      // setTimeout(() => {
      //   console.log(this.routerUrl,'束缚感')
      //   if (this.routerUrl) {
      //     console.log('束缚感')
      //     this.$router.push({
      //       path: '/' + this.routerUrl
      //     })
      //   } else {
      //     console.log('是否')
      //     this.$router.push({
      //       path: '/'
      //     })
      //   }
      // }, 1000)
    },
    beforeDestroy() {},
    methods: {},
    components: {
      // indexIndex
    },
    watch: {}
  };
</script>

<style scoped lang="less" type="text/less">
  .main {
  width: 100%;
  min-height: 800px;
}
.footer {
  height: 250px;
  width: 100%;
  background: #06172a;
  .con {
    // width: 1210px;
	width: 1180px;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/module/index/index.vue